import Banners from './components/Banners'
import FlashDialog from './components/FlashDialog'
import Toasts from './components/Toasts'

const FlashMessages = () => (
  <div id='flash_messages'>
    <Toasts />
    <FlashDialog />
    <Banners />
  </div>
)

export default FlashMessages
